import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import Searchbar from "../../../Components/Searchbar/Searchbar";
import CouponTable from "../../../Components/Table/CouponTable";
import { GetCoupon } from "../../../APIs/Function/Coupon/GetCoupon";
import { SearchDebouncing } from "../../../APIs/Search/SearchDebouncing";

const Coupon = () => {
  const [couponData, setCouponData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const handleCoupon = async () => {
    try {
      setLoading(true);
      let res = await GetCoupon();
      console.log(res.r);
      setLoading(false);
      setCouponData(res.r);
    } catch (error) {
      console.log(error);
    }
  };
  const handleSearch = async (e) => {
    const searchValue = e.target.value.trim();
    if (searchValue.length === 0) {
      setSearchData([]);
      setSearched(false);
      return;
    }

    try {
      await SearchDebouncing(3, searchValue, setSearchData);
      setSearched(true);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleCoupon();
  }, []);

  return (
    <>
      <Box sx={{ boxSizing: "border-box", p: 2 }}>
        {/* searchbar */}
        <Box>
          <Searchbar placeholder={"search"} onChange={handleSearch} />
        </Box>
        {/* Coupon Table */}{" "}
        <Box>
          {searched && searchData.length > 0 ? (
            <CouponTable
              setCouponData={setCouponData}
              loadinga={loading}
              couponData={searchData}
            />
          ) : !searched ? (
            <CouponTable
              setCouponData={setCouponData}
              loadinga={loading}
              couponData={couponData}
            />
          ) : (
            ""
          )}
        </Box>
      </Box>
    </>
  );
};

export default Coupon;
